import { useState, useEffect } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Spacer from './Spacer';

const isDevelopment = process.env.NODE_ENV === 'development';
const myBaseUrl = isDevelopment
  ? process.env.REACT_APP_API_BASE_URL_LOCAL
  : process.env.REACT_APP_API_BASE_URL_DEPLOY;

console.log('Environment:', process.env.NODE_ENV);
console.log('Base URL:', myBaseUrl);

interface HeroProps {
  title: string;
  description: string;
  image: string;
}

const Hero = (): JSX.Element => {
  const theme = useTheme();

  const [hero, setHero] = useState<HeroProps[]>([]);

  const fetchHero = () => {
    axios
      .get<HeroProps[]>(myBaseUrl+'/hero', {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setHero(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchHero();
  }, []);

  return (
    <div id='home'>
      <Box
        sx={{
          paddingY: 10,
          paddingX: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {hero.slice(0, 1).map((item, i) => (
          <Container
            key={i}
            maxWidth='md'
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* Title */}
            <Box marginBottom={2}>
              <Typography
                align='center'
                color={theme.palette.text.primary}
                variant='h3'
                sx={{ fontWeight: 700 }}
                gutterBottom
              >
                {item.title}
              </Typography>
            </Box>

            {/* Description */}
            <Box marginBottom={3}>
              <Typography
                variant='h6'
                component='p'
                color={theme.palette.text.secondary}
                sx={{ fontWeight: 400 }}
              >
                {item.description}
              </Typography>
            </Box>

            {/* Large Figure */}
            {item.image && (
              <Box marginBottom={4}>
                <img
                  src={item.image}
                  alt="Hero figure"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                  }}
                />
              </Box>
            )}
          </Container>
        ))}
      </Box>
      <Spacer sx={{ paddingTop: 6 }} />
    </div>
  );
};

export default Hero;